__turbopack_context__.v({
  "image": "gallery-thumbnail-module__tVQO6q__image",
  "missing": "gallery-thumbnail-module__tVQO6q__missing",
  "selected": "gallery-thumbnail-module__tVQO6q__selected",
  "wrapper": "gallery-thumbnail-module__tVQO6q__wrapper",
});
